import React, { useEffect, useState, useRef } from "react";
import {
  MapContainer,
  TileLayer,
  Marker,
  Popup,
  ZoomControl,
  useMap,
} from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
// IMPORTANTE: Adicione o FiPlus
import { FiSearch, FiMapPin, FiPlus } from "react-icons/fi";
import { renderToStaticMarkup } from "react-dom/server";
import ModalAdicionarObra from "./ModalAdicionarObra"; // Importe o novo modal
import "../css/MapaProject.css";

// ... (MapController e createCustomIcon mantêm-se iguais) ...
// Controlador de Zoom (Voo)
const MapController = ({ position }) => {
  const map = useMap();
  useEffect(() => {
    if (position) {
      map.flyTo(position, 16, { duration: 1.5 });
    }
  }, [position, map]);
  return null;
};

// Criador de ícone SVG
const createCustomIcon = () => {
  const iconMarkup = renderToStaticMarkup(
    <FiMapPin style={{ fontSize: "24px", color: "white" }} />,
  );
  return L.divIcon({
    html: iconMarkup,
    className: "custom-marker-icon",
    iconSize: [40, 40],
    iconAnchor: [20, 40],
    popupAnchor: [0, -40],
  });
};

const MapaProject = () => {
  const [coordenadas, setCoordenadas] = useState([]);
  const [busca, setBusca] = useState("");
  const [projetoSelecionado, setProjetoSelecionado] = useState(null);
  const [mostrarSugestoes, setMostrarSugestoes] = useState(false);
  const [loading, setLoading] = useState(true);

  // Novo estado para o Modal
  const [showModalAdd, setShowModalAdd] = useState(false);

  const wrapperRef = useRef(null);
  const initialPosition = [-22.8164, -45.1933];

  // Função isolada para buscar dados (para poder recarregar depois)
  const carregarCoordenadas = () => {
    setLoading(true);
    fetch("/api/coordenadas")
      .then((res) => res.json())
      .then((data) => {
        setCoordenadas(data);
        setLoading(false);
      })
      .catch((err) => {
        console.error("Erro:", err);
        setLoading(false);
      });
  };

  useEffect(() => {
    carregarCoordenadas();
  }, []);

  // Fecha sugestões ao clicar fora
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setMostrarSugestoes(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const projetosFiltrados = coordenadas.filter((proj) =>
    proj.nome_projeto?.toLowerCase().includes(busca.toLowerCase()),
  );

  const handleSelectProject = (proj) => {
    setProjetoSelecionado([proj.latitude, proj.longitude]);
    setBusca(proj.nome_projeto);
    setMostrarSugestoes(false);
  };

  return (
    <div className="mapa-page">
      <div className="mapa-container">
        {/* --- HEADER COM BOTÃO NOVO --- */}
        <header className="mapa-header">
          <div>
            <h2>Mapa de Obras</h2>
            <span className="subtitle">Geolocalização dos projetos ativos</span>
          </div>
          {/* Botão Adicionar */}
          <button
            className="btn-add-location"
            onClick={() => setShowModalAdd(true)}
          >
            <FiPlus style={{ marginRight: "5px" }} /> Adicionar Obra
          </button>
        </header>

        {/* --- ÁREA DE CONTROLE (BUSCA) --- */}
        <div className="search-wrapper" ref={wrapperRef}>
          <div className="search-bar">
            <FiSearch className="search-icon" />
            <input
              type="text"
              placeholder="Buscar obra por nome..."
              value={busca}
              onChange={(e) => {
                setBusca(e.target.value);
                setMostrarSugestoes(true);
              }}
              onFocus={() => setMostrarSugestoes(true)}
            />
          </div>

          {/* Lista de Sugestões (Dropdown) */}
          {mostrarSugestoes && busca && projetosFiltrados.length > 0 && (
            <div className="search-dropdown">
              {projetosFiltrados.map((proj) => (
                <div
                  key={proj.id}
                  className="dropdown-item"
                  onClick={() => handleSelectProject(proj)}
                >
                  <FiMapPin className="item-icon" />
                  {proj.nome_projeto}
                </div>
              ))}
            </div>
          )}
        </div>

        {/* --- O MAPA --- */}
        <div className="map-frame">
          {loading ? (
            <div className="map-loading">Carregando mapa...</div>
          ) : (
            <MapContainer
              center={initialPosition}
              zoom={13}
              style={{ height: "100%", width: "100%" }}
              zoomControl={false}
            >
              <TileLayer
                attribution="&copy; OpenStreetMap"
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
              />
              <ZoomControl position="bottomright" />
              <MapController position={projetoSelecionado} />

              {coordenadas.map((proj) => (
                <Marker
                  key={proj.id}
                  position={[proj.latitude, proj.longitude]}
                  icon={createCustomIcon()}
                >
                  <Popup className="custom-popup">
                    <div className="popup-content">
                      <img
                        src={
                          proj.imagem ||
                          "https://via.placeholder.com/300x150?text=Sem+Imagem"
                        }
                        alt={proj.nome_projeto}
                        className="popup-img"
                      />
                      <div className="popup-text">
                        <h4>{proj.nome_projeto}</h4>
                        <a
                          href={`/viewprojetocompleto/${proj.id}`}
                          className="btn-popup"
                        >
                          Ver Detalhes
                        </a>
                      </div>
                    </div>
                  </Popup>
                </Marker>
              ))}
            </MapContainer>
          )}
        </div>
      </div>

      {/* --- RENDERIZA O MODAL SE O ESTADO FOR TRUE --- */}
      {showModalAdd && (
        <ModalAdicionarObra
          onClose={() => setShowModalAdd(false)}
          onSuccess={carregarCoordenadas}
        />
      )}
    </div>
  );
};

export default MapaProject;
